export default __webpack_public_path__ + "static/media/documents-2.d26ef920.svg";